import type { ReactNode } from 'react';

/**
 * Shared chrome for every auth page. Centered cream card on a cream
 * field, Newsreader headline, mono "stamp" beneath. Same field-
 * binder feel as the rest of the app, no marketing flourish.
 */
export default function AuthShell({
  stamp,
  title,
  subtitle,
  children,
  footer,
}: {
  stamp: string;
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-md space-y-6">
        <header className="space-y-2 text-center sm:text-left">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
            {stamp}
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-foreground">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm text-muted-foreground max-w-sm mx-auto sm:mx-0">
              {subtitle}
            </p>
          ) : null}
        </header>
        <div className="rounded-lg border border-rule bg-card p-6 shadow-sm">
          {children}
        </div>
        {footer ? (
          <div className="text-center sm:text-left text-sm text-muted-foreground">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
